export { ConfirmationPopoverModule } from './confirmationPopover.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-confirmation-popover/dist/esm/src/index.js
// module id = 1145
// module chunks = 0 1 2